export default {
  editEndpoint: '/user/',
  updateEndpoint: '/user/',
  changeAvatarEndpoint: '/user/change-photo/',
  changePasswordEndpoint: '/user/password',
}
